import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PortalApiRepository } from '../../../../core/repositories/portal-api-repository';
import { CourseVariable } from '../models/CourseVariables';

@Injectable({
  providedIn: 'root',
})
export class CourseVariablesDataService extends PortalApiRepository {
  private readonly path = `/CourseVariables`;

  constructor() {
    super();
  }

  getCourseVariables(): Observable<CourseVariable[]> {
    return this.get<CourseVariable[]>(this.path);
  }

  setCourseVariables(variables: CourseVariable[]): Observable<void> {
    return this.put<CourseVariable[], void>(this.path, variables);
  }
}
